const isoLanguageCodes = [
  {
    family: "Northwest Caucasian",
    name: "Abkhazian",
    nativeName: "аҧсуа бызшәа",
    iso639_1: "ab",
    iso639_2_T: "abk",
    iso639_2_B: "abk",
    iso639_3: "abk",
    endonym: "аҧсшәа",
  },
  {
    family: "Afro-Asiatic",
    name: "Afar",
    nativeName: "Afaraf",
    iso639_1: "aa",
    iso639_2_T: "aar",
    iso639_2_B: "aar",
    iso639_3: "aar",
  },
  {
    family: "Indo-European",
    name: "Afrikaans",
    nativeName: "Afrikaans",
    iso639_1: "af",
    iso639_2_T: "afr",
    iso639_2_B: "afr",
    iso639_3: "afr",
  },
  {
    family: "Niger–Congo",
    name: "Akan",
    nativeName: "Akan",
    iso639_1: "ak",
    iso639_2_T: "aka",
    iso639_2_B: "aka",
    iso639_3: "aka",
    subLanguages: [
      { name: "Fanti", iso639_3: "fat" },
      { name: "Twi", iso639_3: "twi" },
    ],
  },
  {
    family: "Indo-European",
    name: "Albanian",
    nativeName: "Shqip",
    iso639_1: "sq",
    iso639_2_T: "sqi",
    iso639_2_B: "alb",
    iso639_3: "sqi",
    subLanguages: [
      { name: "Arbëreshë Albanian", iso639_3: "aae" },
      { name: "Arvanitika Albanian", iso639_3: "aat" },
      { name: "Gheg Albanian", iso639_3: "aln" },
      { name: "Tosk Albanian", iso639_3: "als" },
    ],
  },
  {
    family: "Afro-Asiatic",
    name: "Amharic",
    nativeName: "አማርኛ",
    iso639_1: "am",
    iso639_2_T: "amh",
    iso639_2_B: "amh",
    iso639_3: "amh",
  },
  {
    family: "Afro-Asiatic",
    name: "Arabic",
    nativeName: "العربية",
    iso639_1: "ar",
    iso639_2_T: "ara",
    iso639_2_B: "ara",
    iso639_3: "ara",
    subLanguages: [
      { name: "Algerian Saharan Arabic", iso639_3: "aao" },
      { name: "Tajiki Arabic", iso639_3: "abh" },
      { name: "Baharna Arabic", iso639_3: "abv" },
      { name: "Mesopotamian Arabic", iso639_3: "acm" },
      { name: "Ta'izzi-Adeni Arabic", iso639_3: "acq" },
      { name: "Hijazi Arabic", iso639_3: "acw" },
      { name: "Omani Arabic", iso639_3: "acx" },
      { name: "Cypriot Arabic", iso639_3: "acy" },
      { name: "Dhofari Arabic", iso639_3: "adf" },
      { name: "Tunisian Arabic", iso639_3: "aeb" },
      { name: "Saidi Arabic", iso639_3: "aec" },
      { name: "Gulf Arabic", iso639_3: "afb" },
      { name: "South Levantine Arabic", iso639_3: "ajp" },
      { name: "North Levantine Arabic", iso639_3: "apc" },
      { name: "Sudanese Arabic", iso639_3: "apd" },
      { name: "Standard Arabic", iso639_3: "arb" },
      { name: "Algerian Arabic", iso639_3: "arq" },
      { name: "Najdi Arabic", iso639_3: "ars" },
      { name: "Moroccan Arabic", iso639_3: "ary" },
      { name: "Egyptian Arabic", iso639_3: "arz" },
      { name: "Uzbeki Arabic", iso639_3: "auz" },
      { name: "Eastern Egyptian Bedawi Arabic", iso639_3: "avl" },
      { name: "Hadrami Arabic", iso639_3: "ayh" },
      { name: "Libyan Arabic", iso639_3: "ayl" },
      { name: "Sanaani Arabic", iso639_3: "ayn" },
      { name: "North Mesopotamian Arabic", iso639_3: "ayp" },
      { name: "Babalia Creole Arabic", iso639_3: "bbz" },
      { name: "Sudanese Creole Arabic", iso639_3: "pga" },
      { name: "Chadian Arabic", iso639_3: "shu" },
      { name: "Shihhi Arabic", iso639_3: "ssh" },
    ],
  },
  {
    family: "Indo-European",
    name: "Aragonese",
    nativeName: "aragonés",
    iso639_1: "an",
    iso639_2_T: "arg",
    iso639_2_B: "arg",
    iso639_3: "arg",
  },
  {
    family: "Indo-European",
    name: "Armenian",
    nativeName: "Հայերեն",
    iso639_1: "hy",
    iso639_2_T: "hye",
    iso639_2_B: "arm",
    iso639_3: "hye",
  },
  {
    family: "Indo-European",
    name: "Assamese",
    nativeName: "অসমীয়া",
    iso639_1: "as",
    iso639_2_T: "asm",
    iso639_2_B: "asm",
    iso639_3: "asm",
  },
  {
    family: "Northeast Caucasian",
    name: "Avaric",
    nativeName: "авар мацӀ",
    iso639_1: "av",
    iso639_2_T: "ava",
    iso639_2_B: "ava",
    iso639_3: "ava",
    endonym: "магӀарул мацӀ",
  },
  {
    family: "Indo-European",
    name: "Avestan",
    nativeName: "avesta",
    iso639_1: "ae",
    iso639_2_T: "ave",
    iso639_2_B: "ave",
    iso639_3: "ave",
  },
  {
    family: "Aymaran",
    name: "Aymara",
    nativeName: "aymar aru",
    iso639_1: "ay",
    iso639_2_T: "aym",
    iso639_2_B: "aym",
    iso639_3: "aym",
    subLanguages: [
      { name: "Southern Aymara", iso639_3: "ayc" },
      { name: "Central Aymara", iso639_3: "ayr" },
    ],
  },
  {
    family: "Turkic",
    name: "Azerbaijani",
    nativeName: "azərbaycan dili",
    iso639_1: "az",
    iso639_2_T: "aze",
    iso639_2_B: "aze",
    iso639_3: "aze",
    subLanguages: [
      { name: "South Azerbaijani", iso639_3: "azb" },
      { name: "North Azerbaijani", iso639_3: "azj" },
    ],
    endonym: "تۆرکجه",
  },
  {
    family: "also known as Azeri",
    name: "",
    nativeName: "",
    iso639_1: "",
    iso639_2_T: "",
    iso639_2_B: "",
    iso639_3: "",
  },
  {
    family: "Niger–Congo",
    name: "Bambara",
    nativeName: "bamanankan",
    iso639_1: "bm",
    iso639_2_T: "bam",
    iso639_2_B: "bam",
    iso639_3: "bam",
  },
  {
    family: "Turkic",
    name: "Bashkir",
    nativeName: "башҡорт теле",
    iso639_1: "ba",
    iso639_2_T: "bak",
    iso639_2_B: "bak",
    iso639_3: "bak",
  },
  {
    family: "Language isolate",
    name: "Basque",
    nativeName: "euskara",
    iso639_1: "eu",
    iso639_2_T: "eus",
    iso639_2_B: "baq",
    iso639_3: "eus",
    endonym: "euskera",
  },
  {
    family: "Indo-European",
    name: "Belarusian",
    nativeName: "беларуская мова",
    iso639_1: "be",
    iso639_2_T: "bel",
    iso639_2_B: "bel",
    iso639_3: "bel",
  },
  {
    family: "Indo-European",
    name: "Bengali",
    nativeName: "বাংলা",
    iso639_1: "bn",
    iso639_2_T: "ben",
    iso639_2_B: "ben",
    iso639_3: "ben",
  },
  {
    family: "Indo-European",
    name: "Bihari languages",
    nativeName: "भोजपुरी",
    iso639_1: "bh",
    iso639_2_T: "bih",
    iso639_2_B: "bih",
    iso639_3: "",
  },
  {
    family: "Creole",
    name: "Bislama",
    nativeName: "Bislama",
    iso639_1: "bi",
    iso639_2_T: "bis",
    iso639_2_B: "bis",
    iso639_3: "bis",
  },
  {
    family: "Indo-European",
    name: "Bosnian",
    nativeName: "bosanski jezik",
    iso639_1: "bs",
    iso639_2_T: "bos",
    iso639_2_B: "bos",
    iso639_3: "bos",
  },
  {
    family: "Indo-European",
    name: "Breton",
    nativeName: "brezhoneg",
    iso639_1: "br",
    iso639_2_T: "bre",
    iso639_2_B: "bre",
    iso639_3: "bre",
  },
  {
    family: "Indo-European",
    name: "Bulgarian",
    nativeName: "български език",
    iso639_1: "bg",
    iso639_2_T: "bul",
    iso639_2_B: "bul",
    iso639_3: "bul",
  },
  {
    family: "Sino-Tibetan",
    name: "Burmese",
    nativeName: "ဗမာစာ",
    iso639_1: "my",
    iso639_2_T: "mya",
    iso639_2_B: "bur",
    iso639_3: "mya",
  },
  {
    family: "Indo-European",
    name: "Catalan, Valencian",
    nativeName: "català",
    iso639_1: "ca",
    iso639_2_T: "cat",
    iso639_2_B: "cat",
    iso639_3: "cat",
    endonym: "valencià",
  },
  {
    family: "Austronesian",
    name: "Chamorro",
    nativeName: "Chamoru",
    iso639_1: "ch",
    iso639_2_T: "cha",
    iso639_2_B: "cha",
    iso639_3: "cha",
  },
  {
    family: "Northeast Caucasian",
    name: "Chechen",
    nativeName: "нохчийн мотт",
    iso639_1: "ce",
    iso639_2_T: "che",
    iso639_2_B: "che",
    iso639_3: "che",
  },
  {
    family: "Niger–Congo",
    name: "Chichewa, Chewa, Nyanja",
    nativeName: "chiCheŵa",
    iso639_1: "ny",
    iso639_2_T: "nya",
    iso639_2_B: "nya",
    iso639_3: "nya",
    endonym: "chinyanja",
  },
  {
    family: "Sino-Tibetan",
    name: "Chinese",
    nativeName: "中文 (Zhōngwén)",
    iso639_1: "zh",
    iso639_2_T: "zho",
    iso639_2_B: "chi",
    iso639_3: "zho",
    endonym: "汉语",
  },
  {
    family: "Turkic",
    name: "Chuvash",
    nativeName: "чӑваш чӗлхи",
    iso639_1: "cv",
    iso639_2_T: "chv",
    iso639_2_B: "chv",
    iso639_3: "chv",
  },
  {
    family: "Indo-European",
    name: "Cornish",
    nativeName: "Kernewek",
    iso639_1: "kw",
    iso639_2_T: "cor",
    iso639_2_B: "cor",
    iso639_3: "cor",
  },
  {
    family: "Indo-European",
    name: "Corsican",
    nativeName: "corsu",
    iso639_1: "co",
    iso639_2_T: "cos",
    iso639_2_B: "cos",
    iso639_3: "cos",
    endonym: "lingua corsa",
  },
  {
    family: "Algonquian",
    name: "Cree",
    nativeName: "ᓀᐦᐃᔭᐍᐏᐣ",
    iso639_1: "cr",
    iso639_2_T: "cre",
    iso639_2_B: "cre",
    iso639_3: "cre",
    subLanguages: [
      { name: "Southern East Cree", iso639_3: "crj" },
      { name: "Plains Cree", iso639_3: "crk" },
      { name: "Northern East Cree", iso639_3: "crl" },
      { name: "Moose Cree", iso639_3: "crm" },
      { name: "Swampy Cree", iso639_3: "csw" },
      { name: "Woods Cree", iso639_3: "cwd" },
    ],
  },
  {
    family: "Indo-European",
    name: "Croatian",
    nativeName: "hrvatski jezik",
    iso639_1: "hr",
    iso639_2_T: "hrv",
    iso639_2_B: "hrv",
    iso639_3: "hrv",
  },
  {
    family: "Indo-European",
    name: "Czech",
    nativeName: "čeština",
    iso639_1: "cs",
    iso639_2_T: "ces",
    iso639_2_B: "cze",
    iso639_3: "ces",
    endonym: "český jazyk",
  },
  {
    family: "Indo-European",
    name: "Danish",
    nativeName: "dansk",
    iso639_1: "da",
    iso639_2_T: "dan",
    iso639_2_B: "dan",
    iso639_3: "dan",
  },
  {
    family: "Indo-European",
    name: "Divehi, Dhivehi, Maldivian",
    nativeName: "ދިވެހި",
    iso639_1: "dv",
    iso639_2_T: "div",
    iso639_2_B: "div",
    iso639_3: "div",
  },
  {
    family: "Indo-European",
    name: "Dutch, Flemish",
    nativeName: "Nederlands",
    iso639_1: "nl",
    iso639_2_T: "nld",
    iso639_2_B: "dut",
    iso639_3: "nld",
    endonym: "Vlaams",
  },
  {
    family: "Sino-Tibetan",
    name: "Dzongkha",
    nativeName: "རྫོང་ཁ",
    iso639_1: "dz",
    iso639_2_T: "dzo",
    iso639_2_B: "dzo",
    iso639_3: "dzo",
  },
  {
    family: "Indo-European",
    name: "English",
    nativeName: "English",
    iso639_1: "en",
    iso639_2_T: "eng",
    iso639_2_B: "eng",
    iso639_3: "eng",
  },
  {
    family: "Constructed",
    name: "Esperanto",
    nativeName: "Esperanto",
    iso639_1: "eo",
    iso639_2_T: "epo",
    iso639_2_B: "epo",
    iso639_3: "epo",
  },
  {
    family: "Uralic",
    name: "Estonian",
    nativeName: "eesti",
    iso639_1: "et",
    iso639_2_T: "est",
    iso639_2_B: "est",
    iso639_3: "est",
    subLanguages: [
      { name: "Standard Estonian", iso639_3: "ekk" },
      { name: "Võro", iso639_3: "vro" },
    ],
    endonym: "eesti keel",
  },
  {
    family: "Niger–Congo",
    name: "Ewe",
    nativeName: "Eʋegbe",
    iso639_1: "ee",
    iso639_2_T: "ewe",
    iso639_2_B: "ewe",
    iso639_3: "ewe",
  },
  {
    family: "Indo-European",
    name: "Faroese",
    nativeName: "føroyskt",
    iso639_1: "fo",
    iso639_2_T: "fao",
    iso639_2_B: "fao",
    iso639_3: "fao",
  },
  {
    family: "Austronesian",
    name: "Fijian",
    nativeName: "vosa Vakaviti",
    iso639_1: "fj",
    iso639_2_T: "fij",
    iso639_2_B: "fij",
    iso639_3: "fij",
  },
  {
    family: "Uralic",
    name: "Finnish",
    nativeName: "suomi",
    iso639_1: "fi",
    iso639_2_T: "fin",
    iso639_2_B: "fin",
    iso639_3: "fin",
    endonym: "suomen kieli",
  },
  {
    family: "Indo-European",
    name: "French",
    nativeName: "français",
    iso639_1: "fr",
    iso639_2_T: "fra",
    iso639_2_B: "fre",
    iso639_3: "fra",
    endonym: "langue française",
  },
  {
    family: "Niger–Congo",
    name: "Fulah",
    nativeName: "Fulfulde",
    iso639_1: "ff",
    iso639_2_T: "ful",
    iso639_2_B: "ful",
    iso639_3: "ful",
    subLanguages: [
      { name: "Maasina Fulfulde", iso639_3: "ffm" },
      { name: "Adamawa Fulfulde", iso639_3: "fub" },
      { name: "Pulaar", iso639_3: "fuc" },
      { name: "Borgu Fulfulde", iso639_3: "fue" },
      { name: "Pular", iso639_3: "fuf" },
      { name: "Western Niger Fulfulde", iso639_3: "fuh" },
      { name: "Bagirmi Fulfulde", iso639_3: "fui" },
      { name: "Central-Eastern Niger Fulfulde", iso639_3: "fuq" },
      { name: "Nigerian Fulfulde", iso639_3: "fuv" },
    ],
    endonym: "Pulaar",
  },
  {
    family: "Indo-European",
    name: "Galician",
    nativeName: "Galego",
    iso639_1: "gl",
    iso639_2_T: "glg",
    iso639_2_B: "glg",
    iso639_3: "glg",
  },
  {
    family: "Kartvelian",
    name: "Georgian",
    nativeName: "ქართული",
    iso639_1: "ka",
    iso639_2_T: "kat",
    iso639_2_B: "geo",
    iso639_3: "kat",
  },
  {
    family: "Indo-European",
    name: "German",
    nativeName: "Deutsch",
    iso639_1: "de",
    iso639_2_T: "deu",
    iso639_2_B: "ger",
    iso639_3: "deu",
  },
  {
    family: "Indo-European",
    name: "Greek, Modern (1453–)",
    nativeName: "ελληνικά",
    iso639_1: "el",
    iso639_2_T: "ell",
    iso639_2_B: "gre",
    iso639_3: "ell",
  },
  {
    family: "Tupian",
    name: "Guarani",
    nativeName: "Avañe'ẽ",
    iso639_1: "gn",
    iso639_2_T: "grn",
    iso639_2_B: "grn",
    iso639_3: "grn",
    subLanguages: [
      { name: "Western Bolivian Guaraní", iso639_3: "gnw" },
      { name: "Paraguayan Guaraní", iso639_3: "gug" },
      { name: "Eastern Bolivian Guaraní", iso639_3: "gui" },
      { name: "Mbyá Guaraní", iso639_3: "gun" },
      { name: "Chiripá", iso639_3: "nhd" },
    ],
  },
  {
    family: "Indo-European",
    name: "Gujarati",
    nativeName: "ગુજરાતી",
    iso639_1: "gu",
    iso639_2_T: "guj",
    iso639_2_B: "guj",
    iso639_3: "guj",
  },
  {
    family: "Creole",
    name: "Haitian, Haitian Creole",
    nativeName: "Kreyòl ayisyen",
    iso639_1: "ht",
    iso639_2_T: "hat",
    iso639_2_B: "hat",
    iso639_3: "hat",
  },
  {
    family: "Afro-Asiatic",
    name: "Hausa",
    nativeName: "(Hausa) هَوُسَ",
    iso639_1: "ha",
    iso639_2_T: "hau",
    iso639_2_B: "hau",
    iso639_3: "hau",
  },
  {
    family: "Afro-Asiatic",
    name: "Hebrew",
    nativeName: "עברית",
    iso639_1: "he",
    iso639_2_T: "heb",
    iso639_2_B: "heb",
    iso639_3: "heb",
  },
  {
    family: "Niger–Congo",
    name: "Herero",
    nativeName: "Otjiherero",
    iso639_1: "hz",
    iso639_2_T: "her",
    iso639_2_B: "her",
    iso639_3: "her",
  },
  {
    family: "Indo-European",
    name: "Hindi",
    nativeName: "हिन्दी",
    iso639_1: "hi",
    iso639_2_T: "hin",
    iso639_2_B: "hin",
    iso639_3: "hin",
    endonym: "हिंदी",
  },
  {
    family: "Austronesian",
    name: "Hiri Motu",
    nativeName: "Hiri Motu",
    iso639_1: "ho",
    iso639_2_T: "hmo",
    iso639_2_B: "hmo",
    iso639_3: "hmo",
  },
  {
    family: "Uralic",
    name: "Hungarian",
    nativeName: "magyar",
    iso639_1: "hu",
    iso639_2_T: "hun",
    iso639_2_B: "hun",
    iso639_3: "hun",
  },
  {
    family: "Constructed",
    name: "Interlingua (International Auxiliary Language Association)",
    nativeName: "Interlingua",
    iso639_1: "ia",
    iso639_2_T: "ina",
    iso639_2_B: "ina",
    iso639_3: "ina",
  },
  {
    family: "Austronesian",
    name: "Indonesian",
    nativeName: "Bahasa Indonesia",
    iso639_1: "id",
    iso639_2_T: "ind",
    iso639_2_B: "ind",
    iso639_3: "ind",
  },
  {
    family: "Constructed",
    name: "Interlingue, Occidental",
    nativeName: "(originally:) Occidental",
    iso639_1: "ie",
    iso639_2_T: "ile",
    iso639_2_B: "ile",
    iso639_3: "ile",
    endonym: "(after WWII:) Interlingue",
  },
  {
    family: "Indo-European",
    name: "Irish",
    nativeName: "Gaeilge",
    iso639_1: "ga",
    iso639_2_T: "gle",
    iso639_2_B: "gle",
    iso639_3: "gle",
  },
  {
    family: "Niger–Congo",
    name: "Igbo",
    nativeName: "Asụsụ Igbo",
    iso639_1: "ig",
    iso639_2_T: "ibo",
    iso639_2_B: "ibo",
    iso639_3: "ibo",
  },
  {
    family: "Eskimo–Aleut",
    name: "Inupiaq",
    nativeName: "Iñupiaq",
    iso639_1: "ik",
    iso639_2_T: "ipk",
    iso639_2_B: "ipk",
    iso639_3: "ipk",
    subLanguages: [
      { name: "North Alaskan Inupiatun", iso639_3: "esi" },
      { name: "Northwest Alaska Inupiatun", iso639_3: "esk" },
    ],
    endonym: "Iñupiatun",
  },
  {
    family: "Constructed",
    name: "Ido",
    nativeName: "Ido",
    iso639_1: "io",
    iso639_2_T: "ido",
    iso639_2_B: "ido",
    iso639_3: "ido",
  },
  {
    family: "Indo-European",
    name: "Icelandic",
    nativeName: "Íslenska",
    iso639_1: "is",
    iso639_2_T: "isl",
    iso639_2_B: "ice",
    iso639_3: "isl",
  },
  {
    family: "Indo-European",
    name: "Italian",
    nativeName: "Italiano",
    iso639_1: "it",
    iso639_2_T: "ita",
    iso639_2_B: "ita",
    iso639_3: "ita",
  },
  {
    family: "Eskimo–Aleut",
    name: "Inuktitut",
    nativeName: "ᐃᓄᒃᑎᑐᑦ",
    iso639_1: "iu",
    iso639_2_T: "iku",
    iso639_2_B: "iku",
    iso639_3: "iku",
    subLanguages: [
      { name: "Eastern Canadian Inuktitut", iso639_3: "ike" },
      { name: "Inuinnaqtun", iso639_3: "ikt" },
    ],
  },
  {
    family: "Japonic",
    name: "Japanese",
    nativeName: "日本語 (にほんご)",
    iso639_1: "ja",
    iso639_2_T: "jpn",
    iso639_2_B: "jpn",
    iso639_3: "jpn",
  },
  {
    family: "Austronesian",
    name: "Javanese",
    nativeName: "ꦧꦱꦗꦮ",
    iso639_1: "jv",
    iso639_2_T: "jav",
    iso639_2_B: "jav",
    iso639_3: "jav",
    endonym: "Basa Jawa",
  },
  {
    family: "Eskimo–Aleut",
    name: "Kalaallisut, Greenlandic",
    nativeName: "kalaallisut",
    iso639_1: "kl",
    iso639_2_T: "kal",
    iso639_2_B: "kal",
    iso639_3: "kal",
    endonym: "kalaallit oqaasii",
  },
  {
    family: "Dravidian",
    name: "Kannada",
    nativeName: "ಕನ್ನಡ",
    iso639_1: "kn",
    iso639_2_T: "kan",
    iso639_2_B: "kan",
    iso639_3: "kan",
  },
  {
    family: "Nilo-Saharan",
    name: "Kanuri",
    nativeName: "Kanuri",
    iso639_1: "kr",
    iso639_2_T: "kau",
    iso639_2_B: "kau",
    iso639_3: "kau",
    subLanguages: [
      { name: "Manga Kanuri", iso639_3: "kby" },
      { name: "Central Kanuri", iso639_3: "knc" },
      { name: "Tumari Kanuri", iso639_3: "krt" },
    ],
  },
  {
    family: "Indo-European",
    name: "Kashmiri",
    nativeName: "कश्मीरी",
    iso639_1: "ks",
    iso639_2_T: "kas",
    iso639_2_B: "kas",
    iso639_3: "kas",
    endonym: "كشميري‎",
  },
  {
    family: "Turkic",
    name: "Kazakh",
    nativeName: "қазақ тілі",
    iso639_1: "kk",
    iso639_2_T: "kaz",
    iso639_2_B: "kaz",
    iso639_3: "kaz",
  },
  {
    family: "Austroasiatic",
    name: "Central Khmer",
    nativeName: "ខ្មែរ",
    iso639_1: "km",
    iso639_2_T: "khm",
    iso639_2_B: "khm",
    iso639_3: "khm",
    endonym: "ខេមរភាសា",
  },
  {
    family: "Niger–Congo",
    name: "Kikuyu, Gikuyu",
    nativeName: "Gĩkũyũ",
    iso639_1: "ki",
    iso639_2_T: "kik",
    iso639_2_B: "kik",
    iso639_3: "kik",
  },
  {
    family: "Niger–Congo",
    name: "Kinyarwanda",
    nativeName: "Ikinyarwanda",
    iso639_1: "rw",
    iso639_2_T: "kin",
    iso639_2_B: "kin",
    iso639_3: "kin",
  },
  {
    family: "Turkic",
    name: "Kirghiz, Kyrgyz",
    nativeName: "Кыргызча",
    iso639_1: "ky",
    iso639_2_T: "kir",
    iso639_2_B: "kir",
    iso639_3: "kir",
    endonym: "Кыргыз тили",
  },
  {
    family: "Uralic",
    name: "Komi",
    nativeName: "коми кыв",
    iso639_1: "kv",
    iso639_2_T: "kom",
    iso639_2_B: "kom",
    iso639_3: "kom",
    subLanguages: [
      { name: "Komi-Permyak", iso639_3: "koi" },
      { name: "Komi-Zyrian", iso639_3: "kpv" },
    ],
  },
  {
    family: "Niger–Congo",
    name: "Kongo",
    nativeName: "Kikongo",
    iso639_1: "kg",
    iso639_2_T: "kon",
    iso639_2_B: "kon",
    iso639_3: "kon",
    subLanguages: [
      { name: "Koongo", iso639_3: "kng" },
      { name: "San Salvador Kongo", iso639_3: "kwy" },
      { name: "Laari", iso639_3: "ldi" },
    ],
  },
  {
    family: "Koreanic",
    name: "Korean",
    nativeName: "한국어",
    iso639_1: "ko",
    iso639_2_T: "kor",
    iso639_2_B: "kor",
    iso639_3: "kor",
  },
  {
    family: "Indo-European",
    name: "Kurdish",
    nativeName: "Kurdî",
    iso639_1: "ku",
    iso639_2_T: "kur",
    iso639_2_B: "kur",
    iso639_3: "kur",
    subLanguages: [
      { name: "Central Kurdish", iso639_3: "ckb" },
      { name: "Northern Kurdish", iso639_3: "kmr" },
      { name: "Southern Kurdish", iso639_3: "sdh" },
    ],
    endonym: "کوردی‎",
  },
  {
    family: "Niger–Congo",
    name: "Kuanyama, Kwanyama",
    nativeName: "Kuanyama",
    iso639_1: "kj",
    iso639_2_T: "kua",
    iso639_2_B: "kua",
    iso639_3: "kua",
  },
  {
    family: "Indo-European",
    name: "Latin",
    nativeName: "latine",
    iso639_1: "la",
    iso639_2_T: "lat",
    iso639_2_B: "lat",
    iso639_3: "lat",
    endonym: "lingua latina",
  },
  {
    family: "Indo-European",
    name: "Luxembourgish, Letzeburgesch",
    nativeName: "Lëtzebuergesch",
    iso639_1: "lb",
    iso639_2_T: "ltz",
    iso639_2_B: "ltz",
    iso639_3: "ltz",
  },
  {
    family: "Niger–Congo",
    name: "Ganda",
    nativeName: "Luganda",
    iso639_1: "lg",
    iso639_2_T: "lug",
    iso639_2_B: "lug",
    iso639_3: "lug",
  },
  {
    family: "Indo-European",
    name: "Limburgan, Limburger, Limburgish",
    nativeName: "Limburgs",
    iso639_1: "li",
    iso639_2_T: "lim",
    iso639_2_B: "lim",
    iso639_3: "lim",
  },
  {
    family: "Niger–Congo",
    name: "Lingala",
    nativeName: "Lingála",
    iso639_1: "ln",
    iso639_2_T: "lin",
    iso639_2_B: "lin",
    iso639_3: "lin",
  },
  {
    family: "Tai–Kadai",
    name: "Lao",
    nativeName: "ພາສາລາວ",
    iso639_1: "lo",
    iso639_2_T: "lao",
    iso639_2_B: "lao",
    iso639_3: "lao",
  },
  {
    family: "Indo-European",
    name: "Lithuanian",
    nativeName: "lietuvių kalba",
    iso639_1: "lt",
    iso639_2_T: "lit",
    iso639_2_B: "lit",
    iso639_3: "lit",
  },
  {
    family: "Niger–Congo",
    name: "Luba-Katanga",
    nativeName: "Kiluba",
    iso639_1: "lu",
    iso639_2_T: "lub",
    iso639_2_B: "lub",
    iso639_3: "lub",
  },
  {
    family: "Indo-European",
    name: "Latvian",
    nativeName: "latviešu valoda",
    iso639_1: "lv",
    iso639_2_T: "lav",
    iso639_2_B: "lav",
    iso639_3: "lav",
    subLanguages: [
      { name: "Latgalian", iso639_3: "ltg" },
      { name: "Standard Latvian", iso639_3: "lvs" },
    ],
  },
  {
    family: "Indo-European",
    name: "Manx",
    nativeName: "Gaelg",
    iso639_1: "gv",
    iso639_2_T: "glv",
    iso639_2_B: "glv",
    iso639_3: "glv",
    endonym: "Gailck",
  },
  {
    family: "Indo-European",
    name: "Macedonian",
    nativeName: "македонски јазик",
    iso639_1: "mk",
    iso639_2_T: "mkd",
    iso639_2_B: "mac",
    iso639_3: "mkd",
  },
  {
    family: "Austronesian",
    name: "Malagasy",
    nativeName: "fiteny malagasy",
    iso639_1: "mg",
    iso639_2_T: "mlg",
    iso639_2_B: "mlg",
    iso639_3: "mlg",
    subLanguages: [
      { name: "Bara Malagasy", iso639_3: "bhr" },
      { name: "Southern Betsimisaraka Malagasy", iso639_3: "bjq" },
      { name: "Northern Betsimisaraka Malagasy", iso639_3: "bmm" },
      { name: "Southern Betsimisaraka Malagasy", iso639_3: "bzc" },
      { name: "Masikoro Malagasy", iso639_3: "msh" },
      { name: "Plateau Malagasy", iso639_3: "plt" },
      { name: "Sakalava Malagasy", iso639_3: "skg" },
      { name: "Tandroy-Mahafaly Malagasy", iso639_3: "tdx" },
      { name: "Tesaka Malagasy", iso639_3: "tkg" },
      { name: "Tanosy Malagasy", iso639_3: "txy" },
      { name: "Antankarana Malagasy", iso639_3: "xmv" },
      { name: "Tsimihety Malagasy", iso639_3: "xmw" },
    ],
  },
  {
    family: "Austronesian",
    name: "Malay",
    nativeName: "Bahasa Melayu",
    iso639_1: "ms",
    iso639_2_T: "msa",
    iso639_2_B: "may",
    iso639_3: "msa",
    subLanguages: [
      { name: "Banjar", iso639_3: "bjn" },
      { name: "Bacanese Malay", iso639_3: "btj" },
      { name: "Berau Malay", iso639_3: "bve" },
      { name: "Bukit Malay", iso639_3: "bvu" },
      { name: "Cocos Islands Malay", iso639_3: "coa" },
      { name: "Duano", iso639_3: "dup" },
      { name: "Haji", iso639_3: "hji" },
      { name: "Indonesian", iso639_3: "ind" },
      { name: "Jakun", iso639_3: "jak" },
      { name: "Jambi Malay", iso639_3: "jax" },
      { name: "Kubu", iso639_3: "kvb" },
      { name: "Kerinci", iso639_3: "kvr" },
      { name: "Brunei", iso639_3: "kxd" },
      { name: "Loncong", iso639_3: "lce" },
      { name: "Lubu", iso639_3: "lcf" },
      { name: "Col", iso639_3: "liw" },
      { name: "North Moluccan Malay", iso639_3: "max" },
      { name: "Kedah Malay", iso639_3: "meo" },
      { name: "Pattani Malay", iso639_3: "mfa" },
      { name: "Bangka", iso639_3: "mfb" },
      { name: "Minangkabau", iso639_3: "min" },
      { name: "Malay (individual language)", iso639_3: "mly" },
      { name: "Kota Bangun Kutai Malay", iso639_3: "mqg" },
      { name: "Sabah Malay", iso639_3: "msi" },
      { name: "Musi", iso639_3: "mui" },
      { name: "Orang Kanaq", iso639_3: "orn" },
      { name: "Orang Seletar", iso639_3: "ors" },
      { name: "Pekal", iso639_3: "pel" },
      { name: "Central Malay", iso639_3: "pse" },
      { name: "Temuan", iso639_3: "tmw" },
      { name: "Urak Lawoi'", iso639_3: "urk" },
      { name: "Kaur", iso639_3: "vkk" },
      { name: "Tenggarong Kutai Malay", iso639_3: "vkt" },
      { name: "Manado Malay", iso639_3: "xmm" },
      { name: "Malay (individual language)", iso639_3: "zlm" },
      { name: "Negeri Sembilan Malay", iso639_3: "zmi" },
      { name: "Standard Malay", iso639_3: "zsm" },
    ],
    endonym: "بهاس ملايو‎",
  },
  {
    family: "Dravidian",
    name: "Malayalam",
    nativeName: "മലയാളം",
    iso639_1: "ml",
    iso639_2_T: "mal",
    iso639_2_B: "mal",
    iso639_3: "mal",
  },
  {
    family: "Afro-Asiatic",
    name: "Maltese",
    nativeName: "Malti",
    iso639_1: "mt",
    iso639_2_T: "mlt",
    iso639_2_B: "mlt",
    iso639_3: "mlt",
  },
  {
    family: "Austronesian",
    name: "Maori",
    nativeName: "te reo Māori",
    iso639_1: "mi",
    iso639_2_T: "mri",
    iso639_2_B: "mao",
    iso639_3: "mri",
  },
  {
    family: "Indo-European",
    name: "Marathi",
    nativeName: "मराठी",
    iso639_1: "mr",
    iso639_2_T: "mar",
    iso639_2_B: "mar",
    iso639_3: "mar",
  },
  {
    family: "Austronesian",
    name: "Marshallese",
    nativeName: "Kajin M̧ajeļ",
    iso639_1: "mh",
    iso639_2_T: "mah",
    iso639_2_B: "mah",
    iso639_3: "mah",
  },
  {
    family: "Mongolic",
    name: "Mongolian",
    nativeName: "Монгол хэл",
    iso639_1: "mn",
    iso639_2_T: "mon",
    iso639_2_B: "mon",
    iso639_3: "mon",
    subLanguages: [
      { name: "Halh Mongolian", iso639_3: "khk" },
      { name: "Peripheral Mongolian", iso639_3: "mvf" },
    ],
  },
  {
    family: "Austronesian",
    name: "Nauru",
    nativeName: "Dorerin Naoero",
    iso639_1: "na",
    iso639_2_T: "nau",
    iso639_2_B: "nau",
    iso639_3: "nau",
  },
  {
    family: "Dené–Yeniseian",
    name: "Navajo, Navaho",
    nativeName: "Diné bizaad",
    iso639_1: "nv",
    iso639_2_T: "nav",
    iso639_2_B: "nav",
    iso639_3: "nav",
  },
  {
    family: "Niger–Congo",
    name: "North Ndebele",
    nativeName: "isiNdebele",
    iso639_1: "nd",
    iso639_2_T: "nde",
    iso639_2_B: "nde",
    iso639_3: "nde",
  },
  {
    family: "Indo-European",
    name: "Nepali",
    nativeName: "नेपाली",
    iso639_1: "ne",
    iso639_2_T: "nep",
    iso639_2_B: "nep",
    iso639_3: "nep",
    subLanguages: [
      { name: "Dotyali", iso639_3: "dty" },
      { name: "Nepali (individual language)", iso639_3: "npi" },
    ],
  },
  {
    family: "Niger–Congo",
    name: "Ndonga",
    nativeName: "Owambo",
    iso639_1: "ng",
    iso639_2_T: "ndo",
    iso639_2_B: "ndo",
    iso639_3: "ndo",
  },
  {
    family: "Indo-European",
    name: "Norwegian Bokmål",
    nativeName: "Norsk Bokmål",
    iso639_1: "nb",
    iso639_2_T: "nob",
    iso639_2_B: "nob",
    iso639_3: "nob",
  },
  {
    family: "Indo-European",
    name: "Norwegian Nynorsk",
    nativeName: "Norsk Nynorsk",
    iso639_1: "nn",
    iso639_2_T: "nno",
    iso639_2_B: "nno",
    iso639_3: "nno",
  },
  {
    family: "Indo-European",
    name: "Norwegian",
    nativeName: "Norsk",
    iso639_1: "no",
    iso639_2_T: "nor",
    iso639_2_B: "nor",
    iso639_3: "nor",
    subLanguages: [
      { name: "Norwegian Nynorsk", iso639_3: "nno" },
      { name: "Norwegian Bokmål", iso639_3: "nob" },
    ],
  },
  {
    family: "Sino-Tibetan",
    name: "Sichuan Yi, Nuosu",
    nativeName: "ꆈꌠ꒿ Nuosuhxop",
    iso639_1: "ii",
    iso639_2_T: "iii",
    iso639_2_B: "iii",
    iso639_3: "iii",
  },
  {
    family: "Niger–Congo",
    name: "South Ndebele",
    nativeName: "isiNdebele",
    iso639_1: "nr",
    iso639_2_T: "nbl",
    iso639_2_B: "nbl",
    iso639_3: "nbl",
  },
  {
    family: "Indo-European",
    name: "Occitan",
    nativeName: "occitan",
    iso639_1: "oc",
    iso639_2_T: "oci",
    iso639_2_B: "oci",
    iso639_3: "oci",
    endonym: "lenga d'òc",
  },
  {
    family: "Algonquian",
    name: "Ojibwa",
    nativeName: "ᐊᓂᔑᓈᐯᒧᐎᓐ",
    iso639_1: "oj",
    iso639_2_T: "oji",
    iso639_2_B: "oji",
    iso639_3: "oji",
    subLanguages: [
      { name: "Chippewa", iso639_3: "ciw" },
      { name: "Northwestern Ojibwa", iso639_3: "ojb" },
      { name: "Central Ojibwa", iso639_3: "ojc" },
      { name: "Eastern Ojibwa", iso639_3: "ojg" },
      { name: "Severn Ojibwa", iso639_3: "ojs" },
      { name: "Western Ojibwa", iso639_3: "ojw" },
      { name: "Ottawa", iso639_3: "otw" },
    ],
  },
  {
    family: "Indo-European",
    name: "Church Slavic, Old Slavonic, Church Slavonic, Old Bulgarian, Old Church Slavonic",
    nativeName: "ѩзыкъ словѣньскъ",
    iso639_1: "cu",
    iso639_2_T: "chu",
    iso639_2_B: "chu",
    iso639_3: "chu",
  },
  {
    family: "Afro-Asiatic",
    name: "Oromo",
    nativeName: "Afaan Oromoo",
    iso639_1: "om",
    iso639_2_T: "orm",
    iso639_2_B: "orm",
    iso639_3: "orm",
    subLanguages: [
      { name: "Borana-Arsi-Guji Oromo", iso639_3: "gax" },
      { name: "West Central Oromo", iso639_3: "gaz" },
      { name: "Eastern Oromo", iso639_3: "hae" },
      { name: "Orma", iso639_3: "orc" },
    ],
  },
  {
    family: "Indo-European",
    name: "Oriya",
    nativeName: "ଓଡ଼ିଆ",
    iso639_1: "or",
    iso639_2_T: "ori",
    iso639_2_B: "ori",
    iso639_3: "ori",
    subLanguages: [
      { name: "Odia", iso639_3: "ory" },
      { name: "Sambalpuri", iso639_3: "spv" },
    ],
  },
  {
    family: "Indo-European",
    name: "Ossetian, Ossetic",
    nativeName: "ирон æвзаг",
    iso639_1: "os",
    iso639_2_T: "oss",
    iso639_2_B: "oss",
    iso639_3: "oss",
  },
  {
    family: "Indo-European",
    name: "Punjabi, Panjabi",
    nativeName: "ਪੰਜਾਬੀ",
    iso639_1: "pa",
    iso639_2_T: "pan",
    iso639_2_B: "pan",
    iso639_3: "pan",
    endonym: "پنجابی‎",
  },
  {
    family: "Indo-European",
    name: "Pali",
    nativeName: "पालि",
    iso639_1: "pi",
    iso639_2_T: "pli",
    iso639_2_B: "pli",
    iso639_3: "pli",
    endonym: "पाळि",
  },
  {
    family: "Indo-European",
    name: "Persian",
    nativeName: "فارسی",
    iso639_1: "fa",
    iso639_2_T: "fas",
    iso639_2_B: "per",
    iso639_3: "fas",
    subLanguages: [
      { name: "Iranian Persian", iso639_3: "pes" },
      { name: "Dari", iso639_3: "prs" },
    ],
  },
  {
    family: "Indo-European",
    name: "Polish",
    nativeName: "język polski",
    iso639_1: "pl",
    iso639_2_T: "pol",
    iso639_2_B: "pol",
    iso639_3: "pol",
    endonym: "polszczyzna",
  },
  {
    family: "Indo-European",
    name: "Pashto, Pushto",
    nativeName: "پښتو",
    iso639_1: "ps",
    iso639_2_T: "pus",
    iso639_2_B: "pus",
    iso639_3: "pus",
    subLanguages: [
      { name: "Southern Pashto", iso639_3: "pbt" },
      { name: "Northern Pashto", iso639_3: "pbu" },
      { name: "Central Pashto", iso639_3: "pst" },
    ],
  },
  {
    family: "Indo-European",
    name: "Portuguese",
    nativeName: "Português",
    iso639_1: "pt",
    iso639_2_T: "por",
    iso639_2_B: "por",
    iso639_3: "por",
  },
  {
    family: "Quechuan",
    name: "Quechua",
    nativeName: "Runa Simi",
    iso639_1: "qu",
    iso639_2_T: "que",
    iso639_2_B: "que",
    iso639_3: "que",
    subLanguages: [
      { name: "Chilean Quechua", iso639_3: "cqu" },
      { name: "Huallaga Huánuco Quechua", iso639_3: "qub" },
      { name: "Calderón Highland Quichua", iso639_3: "qud" },
      { name: "Lambayeque Quechua", iso639_3: "quf" },
      { name: "Chimborazo Highland Quichua", iso639_3: "qug" },
      { name: "South Bolivian Quechua", iso639_3: "quh" },
      { name: "Chachapoyas Quechua", iso639_3: "quk" },
      { name: "North Bolivian Quechua", iso639_3: "qul" },
      { name: "Southern Pastaza Quechua", iso639_3: "qup" },
      { name: "Yanahuanca Pasco Quechua", iso639_3: "qur" },
      { name: "Santiago del Estero Quichua", iso639_3: "qus" },
      { name: "Tena Lowland Quichua", iso639_3: "quw" },
      { name: "Yauyos Quechua", iso639_3: "qux" },
      { name: "Ayacucho Quechua", iso639_3: "quy" },
      { name: "Cusco Quechua", iso639_3: "quz" },
      { name: "Ambo-Pasco Quechua", iso639_3: "qva" },
      { name: "Cajamarca Quechua", iso639_3: "qvc" },
      { name: "Eastern Apurímac Quechua", iso639_3: "qve" },
      { name: "Huamalíes-Dos de Mayo Huánuco Quechua", iso639_3: "qvh" },
      { name: "Imbabura Highland Quichua", iso639_3: "qvi" },
      { name: "Loja Highland Quichua", iso639_3: "qvj" },
      { name: "Cajatambo North Lima Quechua", iso639_3: "qvl" },
      { name: "Margos-Yarowilca-Lauricocha Quechua", iso639_3: "qvm" },
      { name: "North Junín Quechua", iso639_3: "qvn" },
      { name: "Napo Lowland Quechua", iso639_3: "qvo" },
      { name: "Pacaraos Quechua", iso639_3: "qvp" },
      { name: "San Martín Quechua", iso639_3: "qvs" },
      { name: "Huaylla Wanca Quechua", iso639_3: "qvw" },
      { name: "Northern Pastaza Quichua", iso639_3: "qvz" },
      { name: "Corongo Ancash Quechua", iso639_3: "qwa" },
      { name: "Classical Quechua", iso639_3: "qwc" },
      { name: "Huaylas Ancash Quechua", iso639_3: "qwh" },
      { name: "Sihuas Ancash Quechua", iso639_3: "qws" },
      { name: "Chiquián Ancash Quechua", iso639_3: "qxa" },
      { name: "Chincha Quechua", iso639_3: "qxc" },
      { name: "Panao Huánuco Quechua", iso639_3: "qxh" },
      { name: "Salasaca Highland Quichua", iso639_3: "qxl" },
      { name: "Northern Conchucos Ancash Quechua", iso639_3: "qxn" },
      { name: "Southern Conchucos Ancash Quechua", iso639_3: "qxo" },
      { name: "Puno Quechua", iso639_3: "qxp" },
      { name: "Cañar Highland Quichua", iso639_3: "qxr" },
      { name: "Santa Ana de Tusi Pasco Quechua", iso639_3: "qxt" },
      { name: "Arequipa-La Unión Quechua", iso639_3: "qxu" },
      { name: "Jauja Wanca Quechua", iso639_3: "qxw" },
    ],
    endonym: "Kichwa",
  },
  {
    family: "Indo-European",
    name: "Romansh",
    nativeName: "Rumantsch Grischun",
    iso639_1: "rm",
    iso639_2_T: "roh",
    iso639_2_B: "roh",
    iso639_3: "roh",
  },
  {
    family: "Niger–Congo",
    name: "Rundi",
    nativeName: "Ikirundi",
    iso639_1: "rn",
    iso639_2_T: "run",
    iso639_2_B: "run",
    iso639_3: "run",
  },
  {
    family: "Indo-European",
    name: "Romanian, Moldavian, Moldovan",
    nativeName: "Română",
    iso639_1: "ro",
    iso639_2_T: "ron",
    iso639_2_B: "rum",
    iso639_3: "ron",
  },
  {
    family: "Indo-European",
    name: "Russian",
    nativeName: "русский",
    iso639_1: "ru",
    iso639_2_T: "rus",
    iso639_2_B: "rus",
    iso639_3: "rus",
  },
  {
    family: "Indo-European",
    name: "Sanskrit",
    nativeName: "संस्कृतम्",
    iso639_1: "sa",
    iso639_2_T: "san",
    iso639_2_B: "san",
    iso639_3: "san",
  },
  {
    family: "Indo-European",
    name: "Sardinian",
    nativeName: "sardu",
    iso639_1: "sc",
    iso639_2_T: "srd",
    iso639_2_B: "srd",
    iso639_3: "srd",
    subLanguages: [
      { name: "Sassarese Sardinian", iso639_3: "sdc" },
      { name: "Gallurese Sardinian", iso639_3: "sdn" },
      { name: "Logudorese Sardinian", iso639_3: "src" },
      { name: "Campidanese Sardinian", iso639_3: "sro" },
    ],
  },
  {
    family: "Indo-European",
    name: "Sindhi",
    nativeName: "सिन्धी",
    iso639_1: "sd",
    iso639_2_T: "snd",
    iso639_2_B: "snd",
    iso639_3: "snd",
    endonym: "سنڌي، سندھی‎",
  },
  {
    family: "Uralic",
    name: "Northern Sami",
    nativeName: "Davvisámegiella",
    iso639_1: "se",
    iso639_2_T: "sme",
    iso639_2_B: "sme",
    iso639_3: "sme",
  },
  {
    family: "Austronesian",
    name: "Samoan",
    nativeName: "gagana fa'a Samoa",
    iso639_1: "sm",
    iso639_2_T: "smo",
    iso639_2_B: "smo",
    iso639_3: "smo",
  },
  {
    family: "Creole",
    name: "Sango",
    nativeName: "yângâ tî sängö",
    iso639_1: "sg",
    iso639_2_T: "sag",
    iso639_2_B: "sag",
    iso639_3: "sag",
  },
  {
    family: "Indo-European",
    name: "Serbian",
    nativeName: "српски језик",
    iso639_1: "sr",
    iso639_2_T: "srp",
    iso639_2_B: "srp",
    iso639_3: "srp",
  },
  {
    family: "Indo-European",
    name: "Gaelic, Scottish Gaelic",
    nativeName: "Gàidhlig",
    iso639_1: "gd",
    iso639_2_T: "gla",
    iso639_2_B: "gla",
    iso639_3: "gla",
  },
  {
    family: "Niger–Congo",
    name: "Shona",
    nativeName: "chiShona",
    iso639_1: "sn",
    iso639_2_T: "sna",
    iso639_2_B: "sna",
    iso639_3: "sna",
  },
  {
    family: "Indo-European",
    name: "Sinhala, Sinhalese",
    nativeName: "සිංහල",
    iso639_1: "si",
    iso639_2_T: "sin",
    iso639_2_B: "sin",
    iso639_3: "sin",
  },
  {
    family: "Indo-European",
    name: "Slovak",
    nativeName: "Slovenčina",
    iso639_1: "sk",
    iso639_2_T: "slk",
    iso639_2_B: "slo",
    iso639_3: "slk",
    endonym: "Slovenský jazyk",
  },
  {
    family: "Indo-European",
    name: "Slovenian",
    nativeName: "Slovenski jezik",
    iso639_1: "sl",
    iso639_2_T: "slv",
    iso639_2_B: "slv",
    iso639_3: "slv",
    endonym: "Slovenščina",
  },
  {
    family: "Afro-Asiatic",
    name: "Somali",
    nativeName: "Soomaaliga",
    iso639_1: "so",
    iso639_2_T: "som",
    iso639_2_B: "som",
    iso639_3: "som",
    endonym: "af Soomaali",
  },
  {
    family: "Niger–Congo",
    name: "Southern Sotho",
    nativeName: "Sesotho",
    iso639_1: "st",
    iso639_2_T: "sot",
    iso639_2_B: "sot",
    iso639_3: "sot",
  },
  {
    family: "Indo-European",
    name: "Spanish",
    nativeName: "Español",
    iso639_1: "es",
    iso639_2_T: "spa",
    iso639_2_B: "spa",
    iso639_3: "spa",
  },
  {
    family: "Austronesian",
    name: "Sundanese",
    nativeName: "Basa Sunda",
    iso639_1: "su",
    iso639_2_T: "sun",
    iso639_2_B: "sun",
    iso639_3: "sun",
  },
  {
    family: "Niger–Congo",
    name: "Swahili",
    nativeName: "Kiswahili",
    iso639_1: "sw",
    iso639_2_T: "swa",
    iso639_2_B: "swa",
    iso639_3: "swa",
    subLanguages: [
      { name: "Congo Swahili", iso639_3: "swc" },
      { name: "Swahili (individual language)", iso639_3: "swh" },
    ],
  },
  {
    family: "Niger–Congo",
    name: "Swati",
    nativeName: "SiSwati",
    iso639_1: "ss",
    iso639_2_T: "ssw",
    iso639_2_B: "ssw",
    iso639_3: "ssw",
  },
  {
    family: "Indo-European",
    name: "Swedish",
    nativeName: "Svenska",
    iso639_1: "sv",
    iso639_2_T: "swe",
    iso639_2_B: "swe",
    iso639_3: "swe",
  },
  {
    family: "Dravidian",
    name: "Tamil",
    nativeName: "தமிழ்",
    iso639_1: "ta",
    iso639_2_T: "tam",
    iso639_2_B: "tam",
    iso639_3: "tam",
  },
  {
    family: "Dravidian",
    name: "Telugu",
    nativeName: "తెలుగు",
    iso639_1: "te",
    iso639_2_T: "tel",
    iso639_2_B: "tel",
    iso639_3: "tel",
  },
  {
    family: "Indo-European",
    name: "Tajik",
    nativeName: "тоҷикӣ",
    iso639_1: "tg",
    iso639_2_T: "tgk",
    iso639_2_B: "tgk",
    iso639_3: "tgk",
    endonym: "toçikī",
  },
  {
    family: "Tai–Kadai",
    name: "Thai",
    nativeName: "ไทย",
    iso639_1: "th",
    iso639_2_T: "tha",
    iso639_2_B: "tha",
    iso639_3: "tha",
  },
  {
    family: "Afro-Asiatic",
    name: "Tigrinya",
    nativeName: "ትግርኛ",
    iso639_1: "ti",
    iso639_2_T: "tir",
    iso639_2_B: "tir",
    iso639_3: "tir",
  },
  {
    family: "Sino-Tibetan",
    name: "Tibetan",
    nativeName: "བོད་ཡིག",
    iso639_1: "bo",
    iso639_2_T: "bod",
    iso639_2_B: "tib",
    iso639_3: "bod",
  },
  {
    family: "Turkic",
    name: "Turkmen",
    nativeName: "Türkmen",
    iso639_1: "tk",
    iso639_2_T: "tuk",
    iso639_2_B: "tuk",
    iso639_3: "tuk",
    endonym: "Түркмен",
  },
  {
    family: "Austronesian",
    name: "Tagalog",
    nativeName: "Wikang Tagalog",
    iso639_1: "tl",
    iso639_2_T: "tgl",
    iso639_2_B: "tgl",
    iso639_3: "tgl",
  },
  {
    family: "Niger–Congo",
    name: "Tswana",
    nativeName: "Setswana",
    iso639_1: "tn",
    iso639_2_T: "tsn",
    iso639_2_B: "tsn",
    iso639_3: "tsn",
  },
  {
    family: "Austronesian",
    name: "Tonga (Tonga Islands)",
    nativeName: "Faka Tonga",
    iso639_1: "to",
    iso639_2_T: "ton",
    iso639_2_B: "ton",
    iso639_3: "ton",
  },
  {
    family: "Turkic",
    name: "Turkish",
    nativeName: "Türkçe",
    iso639_1: "tr",
    iso639_2_T: "tur",
    iso639_2_B: "tur",
    iso639_3: "tur",
  },
  {
    family: "Niger–Congo",
    name: "Tsonga",
    nativeName: "Xitsonga",
    iso639_1: "ts",
    iso639_2_T: "tso",
    iso639_2_B: "tso",
    iso639_3: "tso",
  },
  {
    family: "Turkic",
    name: "Tatar",
    nativeName: "татар теле",
    iso639_1: "tt",
    iso639_2_T: "tat",
    iso639_2_B: "tat",
    iso639_3: "tat",
    endonym: "tatar tele",
  },
  {
    family: "Niger–Congo",
    name: "Twi",
    nativeName: "Twi",
    iso639_1: "tw",
    iso639_2_T: "twi",
    iso639_2_B: "twi",
    iso639_3: "twi",
  },
  {
    family: "Austronesian",
    name: "Tahitian",
    nativeName: "Reo Tahiti",
    iso639_1: "ty",
    iso639_2_T: "tah",
    iso639_2_B: "tah",
    iso639_3: "tah",
  },
  {
    family: "Turkic",
    name: "Uighur, Uyghur",
    nativeName: "ئۇيغۇرچە‎",
    iso639_1: "ug",
    iso639_2_T: "uig",
    iso639_2_B: "uig",
    iso639_3: "uig",
    endonym: "Uyghurche",
  },
  {
    family: "Indo-European",
    name: "Ukrainian",
    nativeName: "Українська",
    iso639_1: "uk",
    iso639_2_T: "ukr",
    iso639_2_B: "ukr",
    iso639_3: "ukr",
  },
  {
    family: "Indo-European",
    name: "Urdu",
    nativeName: "اردو",
    iso639_1: "ur",
    iso639_2_T: "urd",
    iso639_2_B: "urd",
    iso639_3: "urd",
  },
  {
    family: "Turkic",
    name: "Uzbek",
    nativeName: "Oʻzbek",
    iso639_1: "uz",
    iso639_2_T: "uzb",
    iso639_2_B: "uzb",
    iso639_3: "uzb",
    subLanguages: [
      { name: "Northern Uzbek", iso639_3: "uzn" },
      { name: "Southern Uzbek", iso639_3: "uzs" },
    ],
    endonym: "Ўзбек",
  },
  {
    family: "Niger–Congo",
    name: "Venda",
    nativeName: "Tshivenḓa",
    iso639_1: "ve",
    iso639_2_T: "ven",
    iso639_2_B: "ven",
    iso639_3: "ven",
  },
  {
    family: "Austroasiatic",
    name: "Vietnamese",
    nativeName: "Tiếng Việt",
    iso639_1: "vi",
    iso639_2_T: "vie",
    iso639_2_B: "vie",
    iso639_3: "vie",
  },
  {
    family: "Constructed",
    name: "Volapük",
    nativeName: "Volapük",
    iso639_1: "vo",
    iso639_2_T: "vol",
    iso639_2_B: "vol",
    iso639_3: "vol",
  },
  {
    family: "Indo-European",
    name: "Walloon",
    nativeName: "Walon",
    iso639_1: "wa",
    iso639_2_T: "wln",
    iso639_2_B: "wln",
    iso639_3: "wln",
  },
  {
    family: "Indo-European",
    name: "Welsh",
    nativeName: "Cymraeg",
    iso639_1: "cy",
    iso639_2_T: "cym",
    iso639_2_B: "wel",
    iso639_3: "cym",
  },
  {
    family: "Niger–Congo",
    name: "Wolof",
    nativeName: "Wollof",
    iso639_1: "wo",
    iso639_2_T: "wol",
    iso639_2_B: "wol",
    iso639_3: "wol",
  },
  {
    family: "Indo-European",
    name: "Western Frisian",
    nativeName: "Frysk",
    iso639_1: "fy",
    iso639_2_T: "fry",
    iso639_2_B: "fry",
    iso639_3: "fry",
  },
  {
    family: "Niger–Congo",
    name: "Xhosa",
    nativeName: "isiXhosa",
    iso639_1: "xh",
    iso639_2_T: "xho",
    iso639_2_B: "xho",
    iso639_3: "xho",
  },
  {
    family: "Indo-European",
    name: "Yiddish",
    nativeName: "ייִדיש",
    iso639_1: "yi",
    iso639_2_T: "yid",
    iso639_2_B: "yid",
    iso639_3: "yid",
    subLanguages: [
      { name: "Eastern Yiddish", iso639_3: "ydd" },
      { name: "Western Yiddish", iso639_3: "yih" },
    ],
  },
  {
    family: "Niger–Congo",
    name: "Yoruba",
    nativeName: "Yorùbá",
    iso639_1: "yo",
    iso639_2_T: "yor",
    iso639_2_B: "yor",
    iso639_3: "yor",
  },
  {
    family: "Tai–Kadai",
    name: "Zhuang, Chuang",
    nativeName: "Saɯ cueŋƅ",
    iso639_1: "za",
    iso639_2_T: "zha",
    iso639_2_B: "zha",
    iso639_3: "zha",
    endonym: "Saw cuengh",
  },
  {
    family: "Niger–Congo",
    name: "Zulu",
    nativeName: "isiZulu",
    iso639_1: "zu",
    iso639_2_T: "zul",
    iso639_2_B: "zul",
    iso639_3: "zul",
  },
];

export default isoLanguageCodes;
